import React from 'react'
import styled from 'styled-components'
import { useFormContext } from 'react-hook-form'
import { FieldError } from './FieldError'

export interface RadioButtonGroupProps extends React.ComponentProps<'input'> {
  children: React.ReactNode
  name: string
  legend?: string
  columns?: number
}

const RadioFieldset = styled.fieldset<{ $columns?: number }>`
  border: none;
  padding: 0;
  margin: 0;
  ${({ $columns }) =>
    $columns && $columns > 1
      ? `
    display: grid;
    grid-template-columns: repeat(${$columns}, minmax(0, 1fr));
    gap: var(--grid-16);
    & > div {
      margin-bottom: 0;
    }
  `
      : `
    margin-bottom: calc(-1 * var(--grid-16));
  `}
`

const VisuallyHiddenLegend = styled.legend`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
`

export const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({ ...props }) => {
  const { formState } = useFormContext()

  return (
    <RadioFieldset
      id={props.name}
      className={props.className ?? ''}
      data-testid={`${props.name}-button-group`}
      $columns={props.columns}
    >
      <VisuallyHiddenLegend>{props.legend ?? props.name}</VisuallyHiddenLegend>
      {props.children}
      {formState.errors[props.name] && (
        <FieldError>{formState.errors[props.name]?.message as string | undefined}</FieldError>
      )}
    </RadioFieldset>
  )
}
